import listItemBigIcon from '~/assets/list-item-big.svg'
import listItemIcon from '~/assets/list-item.svg'

import { m } from '~/paraglide/messages'
import { configs } from './config'

export function DonationCard(props: { index: number }) {
  const config = configs[props.index]
  return (
    <div
      class="relative flex w-[273px] flex-1 shrink-0 flex-col overflow-visible rounded-[21px] p-0.5 shadow-[0px_0px_10px_0px_rgba(191,250,255,0.40)]"
      style={{
        'background-image': 'linear-gradient(195deg, #5FD7B3 0%, #C8FFF5 100%)',
      }}
    >
      <div
        class="relative flex flex-1 flex-col gap-6 rounded-[18px] px-6 pb-6 pt-[100px]"
        style={{
          'background-image':
            'linear-gradient(10deg, #8AFFCA 12.5%, #C8FCFF 105%)',
        }}
      >
        <div class="absolute left-1/2 top-[-83px] w-[150px] -translate-x-1/2">
          <img src={config.img} alt="" class="w-full" />
        </div>

        <div class="flex flex-col whitespace-pre-line text-[#176361]">
          <span>{m.donate()}</span>
          <span class="text-[24px] font-bold leading-[34px]">
            {m.forest_energy({ number: String(config.numbers[0]) })}
          </span>
        </div>

        <div class="flex flex-col gap-3">
          <div class="flex items-center gap-[6px]">
            <img src={listItemIcon} alt="" class="size-[15px] shrink-0" />
            <span class="text-sm text-[#333]">
              {m.earth_day_2025_donate_co2_plan({
                number: String(config.numbers[1]),
              })}
            </span>
          </div>
          <div class="flex items-center gap-[6px]">
            <img src={listItemIcon} alt="" class="size-[15px] shrink-0" />
            <span class="text-sm text-[#333]">
              {m.earth_day_2025_donate_land_plan({
                number: String(config.numbers[2]),
              })}
            </span>
          </div>
          <div class="flex items-center gap-[6px]">
            <img src={listItemIcon} alt="" class="size-[15px] shrink-0" />
            <span class="text-sm text-[#333]">
              {m.earth_day_2025_donate_water_plan({
                number: String(config.numbers[3]),
              })}
            </span>
          </div>
          <div class="flex items-center gap-[6px]">
            <img src={listItemBigIcon} alt="" class="size-[15px] shrink-0" />
            <span class="text-sm text-[#333]">
              {m.earth_day_2025_donate_plan_plant()}
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}
